module.exports = __webpack_public_path__ + "static/whyJoinImage1-3e143151a2618071e46d2e387d44ab23.png";